import React from 'react';
import IaFormattedText from './IaFormattedText';

export default function IaFeedbackResultModal({
  open,
  title = 'Análise IA',
  contextLabel,
  markdown,
  autoOpen,
  onAutoOpenChange,
  onClose,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[110] flex items-end justify-center bg-black/75 p-0 backdrop-blur-sm sm:items-center sm:p-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="card max-h-[88vh] w-full overflow-y-auto rounded-t-2xl border-iron-info/40 sm:max-w-lg sm:rounded-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-start justify-between gap-3">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-wider text-iron-muted">{title}</p>
            {contextLabel ? (
              <h2 className="font-display text-xl tracking-wide text-iron-accent">{contextLabel}</h2>
            ) : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-iron-border px-2 py-1 text-iron-muted hover:border-iron-accent hover:text-iron-text"
            aria-label="Fechar"
          >
            ✕
          </button>
        </div>

        {markdown?.trim() ? (
          <div className="rounded-xl border border-iron-border/60 bg-iron-surface/80 p-4">
            <IaFormattedText content={markdown} variant="emphasis" />
          </div>
        ) : (
          <p className="font-mono text-xs text-iron-muted">Sem análise disponível.</p>
        )}

        {typeof onAutoOpenChange === 'function' ? (
          <label className="mt-4 flex cursor-pointer items-start gap-2 rounded-lg border border-iron-border/60 bg-iron-surface/60 px-3 py-2.5">
            <input
              type="checkbox"
              checked={!!autoOpen}
              onChange={(e) => onAutoOpenChange(e.target.checked)}
              className="mt-0.5"
            />
            <span className="font-mono text-[10px] leading-snug text-iron-muted">
              Abrir comentário automaticamente quando a IA terminar
            </span>
          </label>
        ) : null}

        <button type="button" onClick={onClose} className="btn-primary mt-4 w-full py-3">
          Fechar
        </button>
      </div>
    </div>
  );
}
